module.exports = __webpack_public_path__ + "static/media/scroll02_0.7a09a0e0.png";